define(() => {
    'use strict';

    /**
     * @namespace
     */
    return {
        LEGAL_FORM: 'legal_form',

        TYPE_LEGAL: 'legal',
        TYPE_INDIVIDUAL: 'individual',

        FIO: 'fio',
        INN: 'inn',
        OGRN: 'ogrn',
        LEGAL_NAME: 'legal_name',
        PHONE: 'phone',
        PHYSICAL_ADDRESS: 'physical_address',
        KPP: 'kpp',
        LEGAL_POST: 'legal_post',
        LEGAL_CITY: 'legal_city',
        LEGAL_STREET: 'legal_street',
        LEGAL_HOUSE: 'legal_house',
        LEGAL_REGION: 'legal_region',
    };
});
